<template>
  <section
    id="all-entity-views"
    class="all-templates-view bt heightClass overflow-y-auto overflow-x-hidden !rounded-xl"
  >
    <el-row v-if="fileManagementModal">
      <!-- Entity file Management -->
      <div>
        <entity-data-documents
          v-if="!refresh"
          :entityId="selectedFileEntity"
          :folder="folder"
          :showBack="true"
          @moveToFolder="moveToFolder"
          @back="fileManagementModalReset"
        ></entity-data-documents>
      </div>
    </el-row>
    <div v-else>
      <div
        class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
      >
        <div>
          <h3
            class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
            v-if="
              this.$route.query &&
              this.$route.query.group &&
              getSingleEntityGroupData &&
              getSingleEntityGroupData.name
            "
          >
            {{ getSingleEntityGroupData.name }}
          </h3>
          <h3
            v-else
            class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
          >
            {{ 'All Entities' | getMenuTitle }}
          </h3>
        </div>

        <div class="flex items-center justify-start md:!justify-end !gap-3 flex-wrap">
          <el-tooltip
            content="Export All Entities With Data"
            placement="bottom"
            class="export-button"
          >
            <Button
              v-if="IframePermissions('EXPORT', 'EntityList') && total <= 30"
              @click="exportAllEntityData"
              label=""
              type="button"
              class="bg-transparent !border !border-black/20 !px-1 !py-0.5 !rounded-sm bg-white hover:!bg-gray-100"
            >
              <img src="@/assets/img/icons/new/export-icon.svg" alt="" class="!size-4" />
            </Button>
          </el-tooltip>
          <el-select
            class="search"
            v-model="selectedType"
            placeholder="Select Type"
            clearable
            size="mini"
            style="width: 170px"
            @change="fetchEntities()"
            filterable
          >
            <el-option
              v-for="(item, index) of entityTypes"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            class="search"
            prefix-icon="el-icon-search"
            placeholder="Search"
            size="mini"
            v-model="search_string"
            clearable
            @input="searchString"
            :style="getIsMobile ? 'width:130px' : 'width:170px;'"
          ></el-input>
          <button
            v-if="getIframeUrlInfo == null"
            class="hover:!bg-brand-500 flex items-center !gap-1 font-light !text-white !px-2 lg:!px-4 !py-2 lg:!py-1.5 !rounded-md !text-xs 2xl:text-smd !h-fit"
            type="button"
            @click="openNewEntity"
            style="font-family: var(--font-family); background: var(--brand-500) !important"
          >
            <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
            {{ getIsMobile ? '' : 'Create Entity' }}
          </button>
          <el-tooltip content="Create Iframe link" placement="top">
            <el-link
              v-if="getIframeUrlInfo == null && entitySettings('iframe_link')"
              :underline="false"
              class="!border !border-black/20 !px-1.5 !py-[3px] !rounded-sm bg-white hover:!bg-gray-100"
              @click="openViewConfigPage"
            >
              <img src="@/assets/img/icons/new/link-icon.svg" alt="" class="!size-4" />
            </el-link>
          </el-tooltip>
        </div>
      </div>
      <div id="entityTable" class="!p-3">
        <div
          v-loading="configureLoading"
          :element-loading-text="loadingText"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="vue-data-table-default !p-0"
        >
          <data-tables-server
            :fullscreen="true"
            :total="total"
            :data="allEntities"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :pagination-props="paginationProps"
            style="width: 100%"
            v-if="!getIsMobile"
            @query-change="loadData"
            @sort-change="sortChange"
          >
            <el-table-column
              label="Name"
              id="name"
              prop="name"
              width="500"
              fixed="left"
              sortable="custom"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  class="el-dropdown-link !rounded-md !py-1.5 px-2"
                  slot="reference"
                  type="text"
                  :disabled="!IframePermissions('VIEW', 'EntityList')"
                  @click="IframePermissions('VIEW', 'EntityList') ? onView(scope.row) : () => {}"
                >
                  <div style="color: #4c4b4e; font-weight: 400; font-family: var(--font-family)">
                    {{ scope.row.name }}
                    <i class="el-icon-star-on" v-if="scope.row.entity_type === 'BUSINESS'"></i>
                    <i class="el-icon-user" v-if="scope.row.entity_type === 'INDIVIDUAL'"></i>

                    <i class="el-icon-magnet" v-if="scope.row.entity_type === 'GENERAL'"></i>
                  </div>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Actions" prop="action" class="action" width="200">
              <template slot-scope="scope">
                <ul class="action-buttons hover-buttons hover:!text-brand-500 !border-brand-500">
                  <li>
                    <el-dropdown>
                      <el-button size="mini" class="el-dropdown-link !rounded-md !py-1.5 px-2">
                        Actions
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <a
                          v-if="IframePermissions('VIEW', 'EntityList')"
                          @click="onView(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-view" command="view">
                            View
                          </el-dropdown-item>
                        </a>

                        <a @click="goToNewLink(scope.row)" style="border: none">
                          <el-dropdown-item icon="el-icon-view" command="view">
                            View (V2.0)
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="getIframeUrlInfo == null"
                          @click="onEdit(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                            Edit
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="getIframeUrlInfo == null"
                          @click="onRules(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-s-grid" command="rules">
                            Rules
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="IframePermissions('DELETE', 'EntityList')"
                          @click="onDelete(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-delete" command="delete">
                            Delete
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="getIframeUrlInfo == null"
                          @click="openFiles(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-folder">Files</el-dropdown-item>
                        </a>
                        <a
                          style="border: none"
                          @click="openPermissionsDialog(scope.row)"
                          v-if="
                            scope.row.entity_type !== 'GENERAL' &&
                            getIframeUrlInfo == null &&
                            scope.row?.login_mode !== 'rbac'
                          "
                        >
                          <el-dropdown-item icon="el-icon-unlock" command="Permissions">
                            Login Permissions
                          </el-dropdown-item>
                        </a>
                        <a
                          style="border: none"
                          @click="openRBACPermissionsDialog(scope.row)"
                          v-if="
                            scope.row.entity_type !== 'GENERAL' &&
                            getIframeUrlInfo == null &&
                            scope.row?.login_mode === 'rbac'
                          "
                        >
                          <el-dropdown-item icon="el-icon-unlock" command="Permissions">
                            RBAC Permissions
                          </el-dropdown-item>
                        </a>
                        <a
                          @click="openMenuDialog(scope.row)"
                          style="border: none"
                          v-if="
                            scope.row.entity_type !== 'GENERAL' &&
                            getIframeUrlInfo == null &&
                            scope.row?.login_mode !== 'rbac'
                          "
                        >
                          <el-dropdown-item icon="el-icon-menu" command="menu">
                            Custom Menu
                          </el-dropdown-item>
                        </a>
                        <a
                          @click="openRBACMenuDialog(scope.row)"
                          style="border: none"
                          v-if="
                            scope.row.entity_type !== 'GENERAL' &&
                            getIframeUrlInfo == null &&
                            scope.row?.login_mode == 'rbac'
                          "
                        >
                          <el-dropdown-item icon="el-icon-menu" command="menu">
                            Custom Menu
                          </el-dropdown-item>
                        </a>
                        <a
                          @click="openCustomDashboard(scope.row)"
                          style="border: none"
                          v-if="scope.row.entity_type !== 'GENERAL' && getIframeUrlInfo == null"
                        >
                          <el-dropdown-item icon="el-icon-data-analysis" command="menu">
                            Custom Dashboard
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="getIframeUrlInfo == null"
                          @click="openSendNotification(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-s-promotion" command="menu">
                            Send Notification
                          </el-dropdown-item>
                        </a>
                        <a
                          v-if="getIframeUrlInfo == null"
                          @click="openSendWANotification(scope.row)"
                          style="border: none"
                        >
                          <el-dropdown-item icon="el-icon-chat-dot-round" command="menu">
                            Send Notification(WA)
                          </el-dropdown-item>
                        </a>
                        <a @click="openHierarchy(scope.row)" style="border: none">
                          <el-dropdown-item icon="el-icon-s-operation" command="view">
                            Configure Hierarchy
                          </el-dropdown-item>
                        </a>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                </ul>
              </template>
            </el-table-column>
            <el-table-column label="Status" id="status" prop="title" width="200" sortable="custom">
              <template slot-scope="scope" id="category">
                <div class="d-flex activestatus">
                  <div :class="scope.row.status.toLowerCase() + ' circle'"></div>
                  <div>
                    <p v-if="scope.row.status == 'ACTIVE'">Active</p>
                    <p v-else-if="scope.row.status == 'INACTIVE'">Inactive</p>
                    <p v-else>Deleted</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Last Modified"
              prop="updated_at"
              sortable="custom"
              min-width="200"
            >
              <template slot-scope="scope">
                {{ scope.row.updated_at | globalDateTimeFormat }}
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
        <data-tables-server
          :fullscreen="true"
          :total="total"
          :data="allEntities"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          style="width: 100%"
          v-if="getIsMobile"
          @query-change="loadData"
          @sort-change="sortChange"
          class="entities-list-mobile"
          :header-cell-style="{ background: '#F1EFF0' }"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="expand-column-item">
                <div class="expand-column-item-label">Status:</div>
                <div class="expand-column-item-content">
                  <div class="d-flex activestatus">
                    <div :class="scope.row.status.toLowerCase() + ' circle'"></div>
                    <div>
                      <p v-if="scope.row.status == 'ACTIVE'">Active</p>
                      <p v-else-if="scope.row.status == 'INACTIVE'">Inactive</p>
                      <p v-else>Deleted</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Last Modified:</div>
                <div class="expand-column-item-content">
                  <template v-if="scope.row.updated_at">
                    <span class="fs-8 d-inline-block pr-2 text-muted">
                      {{ scope.row.updated_at | globalDateTimeFormat }}
                    </span>
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Name" id="name" min-width="120" fixed>
            <template slot-scope="scope">
              <a class="doc-title" @click="onView(scope.row)">
                {{ scope.row.name | truncate(15, '...') }}
                <i class="el-icon-star-on" v-if="scope.row.entity_type === 'BUSINESS'"></i>
                <i class="el-icon-user" v-if="scope.row.entity_type === 'INDIVIDUAL'"></i>
                <i class="el-icon-magnet" v-if="scope.row.entity_type === 'GENERAL'"></i>
              </a>
            </template>
          </el-table-column>

          <el-table-column prop="action" min-width="100" fixed>
            <template slot-scope="scope">
              <ul class="action-buttons hover-buttons">
                <li>
                  <el-dropdown>
                    <el-button
                      size="mini"
                      class="el-dropdown-link px-2 hover:!text-brand-500 !border-brand-500 hover:!bg-brand-100"
                    >
                      Actions
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <a @click="onView(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                      </a>
                      <a @click="onEdit(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                          Edit
                        </el-dropdown-item>
                      </a>
                      <a @click="onRules(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-s-grid" command="rules">
                          Rules
                        </el-dropdown-item>
                      </a>
                      <a @click="onDelete(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-delete" command="delete">
                          Delete
                        </el-dropdown-item>
                      </a>
                      <a @click="openFiles(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-folder">Files</el-dropdown-item>
                      </a>
                      <a @click="openSendNotification(scope.row)" style="border: none">
                        <el-dropdown-item icon="el-icon-s-promotion">
                          Send notification
                        </el-dropdown-item>
                      </a>
                      <a
                        v-if="getIframeUrlInfo == null"
                        @click="openSendWANotification(scope.row)"
                        style="border: none"
                      >
                        <el-dropdown-item icon="el-icon-s-promotion" command="menu">
                          Send notification(WA)
                        </el-dropdown-item>
                      </a>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
              </ul>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
    <dialog-component
      id="settingsDialog"
      :title="'New Entity Information'"
      :visible="newEntityModal"
      class="doc-modal new-entity-information"
      v-loading="modalLoading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      @before-close="destroyCreateModal"
      :containerWidth="getIsMobile ? '100%' : '45%'"
      :containerHeight="'80%'"
    >
      <el-form label-position="top">
        <div class="grid grid-cols-[auto_1fr] !gap-4 !items-end">
          <div class="icon-dropdown-selection">
            <el-button
              id="brandSVG"
              type="text"
              class="!border-none !bg-transparent !p-0"
              @click="iconPickerdialogVisible = true"
            >
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500 !text-xl"></i>
              </div>
            </el-button>
          </div>
          <div>
            <p class="!mt-0 !mb-1">
              Title
              <span class="text-danger">*</span>
            </p>
            <el-input
              class="!w-full"
              type="text"
              placeholder="Title"
              v-model="entityName"
            ></el-input>
          </div>
        </div>
        <div class="!mb-4">
          <p class="!mt-4 !mb-1">Description</p>
          <el-input
            class="!w-full"
            type="textarea"
            placeholder="Description"
            v-model="description"
          ></el-input>
        </div>
        <el-row>
          <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
            <p class="!mb-1">Entity Type</p>
            <el-radio-group
              size="mini"
              v-model="entity_type"
              fill="#409EFF"
              style="margin-bottom: 1rem; margin-left: 0rem"
              class="entity-type-radio"
            >
              <div class="radio-group">
                <el-radio-button
                  label="GENERAL"
                  @click.native="isAccount = false"
                ></el-radio-button>
                <el-radio-button
                  label="BUSINESS"
                  @click.native="isAccount = true"
                ></el-radio-button>
                <el-radio-button
                  label="INDIVIDUAL"
                  @click.native="isAccount = true"
                ></el-radio-button>
              </div>
            </el-radio-group>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" v-if="!this.$route.query.group">
            <div class="flex items-center justify-between !mb-1">
              <p class="">
                Groups
                <span class="text-danger">*</span>
              </p>
              <el-tooltip content="Add New Group" placement="top" effect="light">
                <i class="el-icon-circle-plus-outline !text-brand-500" @click="addGroupPopUP"></i>
              </el-tooltip>
            </div>
            <el-select
              v-model="entityGroupsData"
              placeholder="Select Group"
              multiple
              filterable
              collapse-tags
              class="!w-full"
            >
              <el-option
                v-for="(item, index) of getAllEntityGroupsData"
                v-bind:key="index"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" align="middle" class="mt-1">
          <el-col :span="16">
            <el-tooltip
              class="item"
              effect="dark"
              content="If selected, multiple users cannot edit the entity data at the same time."
              placement="top"
            >
              <el-checkbox v-model="isRestrictMultiple">
                Allow single-user editing at a time to edit
              </el-checkbox>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-form-item class="!mt-2 lg:!mt-0">
          <div class="entity-box d-flex flex-row">
            <div
              class="entity-type-box cursor-pointer"
              @click="selectScratchbox"
              :style="
                isCreateFromScratchSelected
                  ? 'border-color: var(--brand-500); border-width: 2px;'
                  : ''
              "
            >
              <el-row>
                <el-col :xl="22" :lg="22" :md="22" :sm="24" :xs="24">
                  <i
                    class="el-icon-plus !text-xl"
                    :class="isCreateFromScratchSelected ? '!text-brand-500' : ''"
                  ></i>
                </el-col>
                <el-col :xl="2" :lg="2" :md="2" :sm="24" :xs="24">
                  <el-radio v-model="selectedEntityCreationType" label="scratch">
                    <span></span>
                  </el-radio>
                </el-col>
              </el-row>
              <h4
                class="!font-normal"
                :class="isCreateFromScratchSelected ? '!text-brand-500' : '!text-black-950'"
              >
                Start from scratch
              </h4>
              <p>Create a new app base with custom fields,tables, and filters.</p>
            </div>
            <div
              class="entity-type-box cursor-pointer"
              @click="selectExcelbox"
              :style="
                isCreateFromExcelSelected
                  ? 'border-color: var(--brand-500); border-width: 2px;'
                  : ''
              "
            >
              <el-row>
                <el-col :xl="22" :lg="22" :md="22" :sm="24" :xs="24">
                  <i
                    class="el-icon-document-delete !text-xl"
                    :class="isCreateFromExcelSelected ? '!text-brand-500' : ''"
                  ></i>
                </el-col>
                <el-col :xl="2" :lg="2" :md="2" :sm="24" :xs="24">
                  <el-radio v-model="selectedEntityCreationType" label="excel">
                    <span></span>
                  </el-radio>
                </el-col>
              </el-row>
              <h4
                class="!font-normal"
                :class="isCreateFromExcelSelected ? '!text-brand-500' : '!text-black-950'"
              >
                Create from excel
              </h4>
              <p>Transfer your current data into the system to generate an application.</p>
            </div>
          </div>
        </el-form-item>
        <!-- </div> -->
      </el-form>

      <span slot="footer" style="text-align: right">
        <button
          class="!mr-1 !px-3 !py-1 !border !rounded-sm !border-black/10 hover:border hover:!border-brand-500 hover:text-brand-500"
          type="button"
          @click="newEntityModal = false"
        >
          Cancel
        </button>
        <button
          class="!border !border-brand-500 !px-3 !py-1 !bg-brand-500 !text-white !rounded-sm"
          style="background: var(--brand-500)"
          type="button"
          :disabled="!entityName.trim()"
          @click="createEntity"
        >
          Confirm
        </button>
      </span>
    </dialog-component>

    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
    <dialog-component
      :title="'Add New Group'"
      :visible="showAddGroupDialog"
      :containerWidth="getIsMobile ? '100%' : '30%'"
      @before-close="showAddGroupDialog = false"
      :isShowFooter="false"
    >
      <el-form
        class="m-tb-2"
        :model="entitiesListForm"
        ref="entitiesListForm"
        :rules="rules"
        @submit.native.prevent="saveGroup"
      >
        <el-form-item label="Group Title" prop="groupName">
          <el-input
            type="text"
            v-model="entitiesListForm.groupName"
            placeholder="Enter Title"
            :style="{ height: '50px' }"
          ></el-input>
        </el-form-item>
        <div class="flex items-center justify-end !mb-4">
          <el-form-item class="!mb-0">
            <button
              class="!mr-1 !px-3 !py-1 !border !rounded-sm !border-black/10 hover:border hover:!border-brand-500 hover:text-brand-500"
              type="button"
              @click="showAddGroupDialog = false"
            >
              Cancel
            </button>
          </el-form-item>
          <el-form-item class="!mb-0">
            <button
              class="btn btn-outline-primary btn-sm m-lr-1 !border-brand-500 !rounded-md"
              style="background-color: var(--brand-500)"
              type="button"
              @click="saveGroup"
              :disabled="loadingSaveGroup"
            >
              <i v-if="loadingSaveGroup" class="fa fa-spinner fa-spin"></i>
              <i v-else class="fa fa-check-square-o"></i>
              {{ loadingSaveGroup ? 'Saving...' : 'Save Group' }}
            </button>
          </el-form-item>
        </div>
      </el-form>
    </dialog-component>
    <dialog-component
      :title="'Login permissions'"
      :visible="showPermissionsDialog"
      :containerWidth="'75vw'"
      @before-close="showPermissionDialog"
      :isShowFooter="false"
    >
      <div v-if="selectedEntity && selectedEntity._id" class="mt-3">
        <Permissions
          v-if="showPermissionsDialog"
          :selectedEntityId="selectedEntity._id"
          v-on:close="resetEntityPermissions"
          v-on:save="saveEntityPermissions"
        ></Permissions>
      </div>
    </dialog-component>
    <dialog-component
      :title="
        'Role Based Access Control for ' +
        (selectedEntity && selectedEntity.name ? selectedEntity.name : '')
      "
      :visible="showRBACPermissionsDialog"
      :containerWidth="'75vw'"
      @before-close="handleCloseDialog"
      :isShowFooter="false"
    >
      <div v-if="selectedEntity && selectedEntity._id" class="mt-3">
        <RoleBasedAccessControlPermissions
          v-if="showRBACPermissionsDialog"
          :selectedEntityId="selectedEntity._id"
          v-on:close="resetEntityPermissions"
          v-on:save="saveEntityPermissions"
        ></RoleBasedAccessControlPermissions>
      </div>
    </dialog-component>
    <dialog-component
      :title="(selectedEntity && selectedEntity.name ? selectedEntity.name : '') + ' Custom Menu'"
      :visible="showRBACMenuDialog"
      :containerWidth="'60%'"
      :containerHeight="'90%'"
      @before-close="showCustomMenuDialog"
      :isShowFooter="false"
      class="custom-menu-style"
    >
      <div v-if="selectedEntity && selectedEntity._id" class="popUp-content">
        <RBACCustomMenu
          :selectedEntityId="selectedEntity._id"
          v-if="showRBACMenuDialog"
        ></RBACCustomMenu>
      </div>
    </dialog-component>
    <dialog-component
      :title="(selectedEntity && selectedEntity.name ? selectedEntity.name : '') + ' Custom Menu'"
      :visible="showMenuDialog"
      :containerWidth="'70%'"
      :containerHeight="'90%'"
      @before-close="showCustomMenuDialog"
      :isShowFooter="false"
      class="custom-menu-style"
    >
      <div v-if="selectedEntity && selectedEntity._id" class="popUp-content">
        <CustomMenu :selectedEntityId="selectedEntity._id" v-if="showMenuDialog"></CustomMenu>
      </div>
    </dialog-component>
    <dialog-component
      :title="'Delete & Edit Rules'"
      :visible="entityDataRulesModal"
      :containerWidth="getIsMobile ? '100%' : '60%'"
      :isShowFooter="false"
      @before-close="entityDataRulesModalDialog"
    >
      <div v-if="selectedEntity && selectedEntity._id">
        <EntityRules
          v-if="entityDataRulesModal"
          :selectedEntityId="selectedEntity._id"
          :currentEntity="selectedEntity"
          v-on:close="resetEntityRules"
          v-on:save="saveEntityRules"
        ></EntityRules>
      </div>
    </dialog-component>
    <dialog-component
      :title="'Bulk Notification'"
      :visible="sendNotificationDialog"
      @before-close="sendNotificationsDialog"
      v-loading="entityNotificationLoading"
      :isShowFooter="true"
      :containerWidth="getIsMobile ? '100%' : '52%'"
      :containerMinHeight="'100%'"
      :containerMaxHeight="'100%'"
    >
      <EmailConfig
        ref="emailConfigRef"
        :currentEntity="selectedNotifyEntity"
        :isSendIndividual="false"
        :paramsContent="paramsContent"
        :emailTemplateId="selectedNotifyEntity.default_email_template"
        :parentEmailTemplateId="selectedNotifyEntity.default_parent_template"
        v-on:closeNotificationDialog="closeBulkSendNotificationDialog"
      ></EmailConfig>
      <template #footer>
        <div class="flex items-center !gap-4 justify-end !m-0 !w-full !px-3">
          <a
            v-if="!entityNotificationLoading"
            :disabled="emailConfigRef?.isTemplateCreated"
            @click="handleSaveAsTemplate"
            class="cursor-pointer !text-brand-500 text-xs 2xl:text-smd !border bg-transparent !border-brand-500 border-solid !px-3 !py-1.5 !rounded-md"
          >
            Save As Template
          </a>
          <a
            v-loading="entityNotificationLoading"
            :disabled="emailConfigRef?.checkIsDisabled()"
            @click="handleSendNotification"
            style="background: var(--brand-500) !important"
            class="cursor-pointer text-white !px-3 !py-1.5 !rounded-md flex items-center !gap-1 !border !border-brand-500"
          >
            <img src="@/assets/img/icons/new/send-icon.svg" alt="" class="!size-3" />
            <span class="text-xs 2xl:text-smd">Send</span>
          </a>
        </div>
      </template>
    </dialog-component>
    <dialog-component
      :title="'Bulk Whatsapp Notification'"
      :visible="sendWANotificationDialog"
      @before-close="sendNotificationsDialog"
      v-loading="entityNotificationLoading"
      element-loading-text="Please wait while we process your request."
      :isShowFooter="false"
      :containerWidth="'52%'"
      :containerMinHeight="'50%'"
    >
      <div class="popUp-content">
        <WAConfig
          :currentEntity="selectedNotifyEntity"
          :isSendIndividual="false"
          :paramsContent="paramsContent"
          v-on:closeNotificationDialog="closeBulkSendNotificationDialog"
        ></WAConfig>
      </div>
    </dialog-component>

    <el-drawer
      title="Privacy Link"
      :visible.sync="copyModal"
      :direction="'rtl'"
      :with-header="true"
      :size="getIsMobile ? '80%' : '28%'"
    >
      <IframeLink :routeKey="url_key" type="EntityList"></IframeLink>
    </el-drawer>
    <el-drawer
      :title="hierarchyEntityName"
      :visible.sync="hierarchyVisible"
      direction="rtl"
      :with-header="true"
      :size="getIsMobile ? '80%' : '35%'"
      @close="closeHierarchy()"
    >
      <div v-loading="loadingDrawer" :element-loading-text="loadingText" class="p-4">
        <div
          class="p-2 bg-white border border-gray-300 rounded-lg mb-4 flex items-center justify-between"
        >
          <label class="text-sm font-medium text-gray-700 mb-1 block">Hierarchy Mode:</label>
          <el-select
            v-model="hierarchyMode"
            size="mini"
            placeholder="Select hierarchy mode"
            @change="onHierarchyModeChange"
          >
            <el-option label="Based on Role" value="role" />
            <el-option label="Based on Relationship" value="relationship" />
          </el-select>
        </div>
        <div v-if="hierarchyMode === 'relationship'">
          <div
            v-for="(level, index) in wantedHierarchyList"
            :key="index"
            class="d-flex justify-between items-center bg-white shadow-sm border border-gray-300 text-sm px-4 py-2 rounded-lg mb-2 main-container"
          >
            <span>{{ `${index + 1}.` }}</span>
            <el-select
              v-model="wantedHierarchyList[index].entity_id"
              size="mini"
              placeholder="Select entity"
              class="w-40"
              :disabled="index == 0"
              @change="updateWantedHierarchyList($event, index)"
            >
              <el-option
                v-for="entity in availableOptionsPerLevel[index]"
                :key="entity._id"
                :label="entity.name"
                :value="entity._id"
              />
            </el-select>
            <!-- Select Entity Image -->
            <el-select
              v-model="level.selectedImage"
              size="mini"
              placeholder="Select image field"
              class="w-40"
            >
              <el-option
                v-for="option in level.imageFields"
                :key="option.key"
                :label="option.label"
                :value="option.key"
              />
            </el-select>
            <!-- Add New Level Button -->
            <el-button
              v-if="index === wantedHierarchyList.length - 1"
              type="success"
              icon="el-icon-plus"
              plain
              size="mini"
              @click="addNewLevel(wantedHierarchyList[index].entity_id, index)"
            >
              Add Level
            </el-button>
            <!-- Add Delete Button -->
            <i
              class="el-icon-delete text-lg ml-3"
              :class="
                index === 0 ? 'text-gray-400 cursor-not-allowed' : 'text-danger cursor-pointer'
              "
              @click="index !== 0 && removeLevel(index)"
            ></i>
          </div>

          <div v-if="wantedHierarchyList.length === 0" class="text-gray-500 mt-4">
            No hierarchy levels defined.
          </div>
          <el-checkbox v-model="fetchBasedOnAllParents" class="mt-2">
            Apply data fetch using all parent entities
          </el-checkbox>
        </div>
        <div v-else>
          <div
            class="p-2 bg-white border border-gray-300 rounded-lg mb-4 flex items-center justify-between"
          >
            <!-- Label on top -->
            <label>Select Reported To Field:</label>

            <el-select
              v-model="roleSettings.reported_to"
              size="mini"
              placeholder="Select role entity"
            >
              <el-option
                v-for="(field, index) in hierarchyEntityFields"
                :key="index"
                :label="field.label"
                :value="field.template_key"
              />
            </el-select>
          </div>
          <div
            class="p-2 bg-white border border-gray-300 rounded-lg mb-4 flex items-center justify-between"
          >
            <!-- Label on top -->
            <label>Select Role Name:</label>

            <el-select
              v-model="roleSettings.role_name"
              size="mini"
              placeholder="Select role name field"
            >
              <el-option
                v-for="(field, index) in hierarchyEntityFields"
                :key="index"
                :label="field.label"
                :value="field.template_key"
              />
            </el-select>
          </div>
        </div>

        <!-- Footer -->
        <div style="width: 100%; padding: 16px 16px 16px 0; border-top: 1px solid #e4e7ed">
          <div style="float: right">
            <el-button @click="closeHierarchy" style="border-radius: 8px" size="small">
              Cancel
            </el-button>
            <el-button
              type="primary"
              @click="saveHierarchy"
              style="border-radius: 8px"
              size="small"
            >
              {{ isHierarchyExist ? 'Update' : 'Save' }}
            </el-button>
            <el-button
              type="primary"
              @click="resetHierarchy"
              style="border-radius: 8px"
              size="small"
            >
              Reset
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import EntitiesHelper from '@/mixins/EntitiesHelper';
  import Permissions from './ApplicationUserPermissions.vue';
  import RoleBasedAccessControlPermissions from './RoleBasedAccessControlPermissions.vue';
  import CustomMenu from './ApplicationUserMenu.vue';
  import RBACCustomMenu from './RoleBasedAccessControlMenu.vue';
  import { postAPICall } from '@/helpers/httpHelper';
  import { createIcons, getIconKeysFromMasterIcons } from '@/repo/iconsRepo';
  import {
    fetchEntitiesByPagination,
    deleteEntity,
    addSingleEntityToLocal,
    updateEntityData,
  } from '../../repo/entityRepo';
  import { fetchGroups, addSingleGroupToLocal } from '@/repo/groupsRepo';
  import AccessManagement from '../../mixins/AccessManagement';
  export default {
    name: 'Entity-EntitiesList',
    data() {
      return {
        hasAccess: true,
        search_string: '',
        entitiesListForm: {
          groupName: '',
        },
        rules: {
          groupName: [
            {
              required: true,
              message: 'Group Title is required',
              trigger: 'blur',
            },
          ],
        },
        iconPickerdialogVisible: false,
        templateIconPath: 'block-portfolio.svg',
        configureLoading: false,
        total: 0,
        activeStep: 0,
        currentPage: 1,
        pageSize: 0,
        fetchBasedOnAllParents: false,
        page: 1,
        newEntityModal: false,
        entityName: '',
        description: '',
        hierarchyMode: null,
        isAccount: false,
        loadingDrawer: '',
        hierarchyVisible: false,
        hierarchyList: [],
        availableOptionsPerLevel: [],
        hierarchyEntityName: '',
        hierarchyEntity: null,
        hierarchyEntityFields: [],
        loadingText: 'Loading...',
        wantedHierarchyList: [],
        availableOptions: [],
        isRBACEnabled: false,
        roleSettings: { reported_to: '', role_details: {}, role_name: '' },
        isHierarchyExist: false,
        entity_type: 'GENERAL',
        modalLoading: false,
        allEntities: [],
        showAddGroupDialog: false,
        loadingSaveGroup: false,
        entityGroupsData: [],
        showPermissionsDialog: false,
        showRBACPermissionsDialog: false,
        selectedEntity: null,
        showMenuDialog: false,
        showRBACMenuDialog: false,
        isCreateFromScratchSelected: true,
        isCreateFromExcelSelected: false,
        selectedEntityCreationType: 'scratch', // 'scratch' or 'excel'
        //Entity notification variables
        entityNotificationLoading: false,
        sendNotificationDialog: false,
        sendWANotificationDialog: false,
        paramsData: {},
        emailConfigLoading: false,
        selectedNotifyEntity: {
          _id: '',
        },
        selectedFileEntity: null,
        fileManagementModal: false,
        refresh: false,
        folder: '',
        entityDataRulesModal: false,
        entityTypes: [
          {
            name: 'Individual',
            value: 'INDIVIDUAL',
          },
          {
            name: 'Business',
            value: 'BUSINESS',
          },
          {
            name: 'General',
            value: 'GENERAL',
          },
        ],
        selectedType: '',
        files: [],
        paramsContent: {},
        getAllEntityGroupsData: [],
        copyModal: false,
        url_key: '',
        isRestrictMultiple: false,
      };
    },
    mixins: [
      PermissionsHelper,
      NavigationHelper,
      EntitiesHelper,
      AutomationHelper,
      AccessManagement,
    ],
    computed: {
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getUserType',
        'getWorkspaceList',
        'getUserTypeEmailsErrors',
        'getUserTypeEmails',
        'getUserTypeList',
      ]),
      ...mapGetters('entityGroups', ['getSingleEntityGroupData']),
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('entities', [
        'getAllEntities',
        'getEntityCreatedStatus',
        'getEntityCreatedData',
        'getEntityDeleteStatus',
        'getEntityDeleteError',
        'getEntityErrors',
        'getEntityDataUpdateStatus',
        'getSentEntityNotificationStatus',
        'getSentEntityNotificationStatusErrors',
        'getEntityVariableFieldsInputTypes',
      ]),
      ...mapGetters('entityGroups', [
        'getSingleEntityGroupData',
        'getEntityGroupErrors',
        'getError',
      ]),
      ...mapGetters('roles', ['getRoleById', 'getSuccess', 'getRoleErrors']),
      ...mapGetters('customDashboard', ['getEntityCustomDashboard']),
      ...mapGetters('filters', ['getAllEntityFilters']),
      ...mapGetters('entityEmailTemplate', [
        'getEntityEmailTemplatesData',
        'getEmailTemplateError',
      ]),
      ...mapGetters('s3FileUpload', [
        'getFileUploadData',
        'getCompanyLogoUpdateData',
        'getFileUploadStatus',
      ]),
      ...mapGetters('sso', ['getAuthenticatedSSOToken', 'getIsUserLoggedIn']),
      ...mapGetters('iFrame', ['getIframeUrlInfo']),
      ...mapGetters('company', ['getCompanyDetails']),
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 20, 50],
        };
      },
    },
    components: {
      Permissions,
      RoleBasedAccessControlPermissions,
      CustomMenu,
      RBACCustomMenu,
      EntityDataDocuments: () => import('./EntityDataDocuments.vue'),
      EntityRules: () => import('./EntityRules.vue'),
      EmailConfig: () => import('../notifications/emailConfig.vue'),
      WAConfig: () => import('../notifications/WAConfig.vue'),
      IframeLink: () => import('../../views/iframeLink.vue'),
    },
    async mounted() {
      await this.fetchGroupDetails();
      await this.fetchEntities();
      if (this.$route.path.includes('/if/')) {
        await this.isIframe();
      }
    },
    methods: {
      entitySettings(item) {
        const items = this.getCompanyDetails?.company_settings?.entity_gridview_settings;
        if (!items) {
          return true;
        }
        return items.includes(item);
      },
      updateWantedHierarchyList(selectedId, index) {
        const selectedEntity = this.hierarchyList.find((entity) => entity._id === selectedId);
        this.wantedHierarchyList[index].entity_id = selectedEntity._id;
        this.wantedHierarchyList[index].entity = selectedEntity;
        this.wantedHierarchyList[index].selectedImage = null;
        this.wantedHierarchyList[index].imageFields = this.getImageFields(selectedEntity);
        this.wantedHierarchyList.splice(index + 1, this.wantedHierarchyList.length - index);
      },
      async addNewLevel(entityId, index) {
        let response = await postAPICall('GET', '/fetch-parent-related-entities', {
          entity_id: entityId,
        });
        if (response.data.length) {
          this.wantedHierarchyList.push({
            entity_id: null,
            entity: null,
            selectedImage: null,
            imageFields: [], // optional, if you want to precompute or leave empty
          });
          this.availableOptionsPerLevel[index + 1] = this.hierarchyList.filter((entity) =>
            response.data.includes(entity._id)
          );
        } else {
          this.$notify.error({
            message: 'The selected entity does not have any child entities to add.',
            title: 'Warning',
          });
        }
      },
      closeHierarchy() {
        ((this.isHierarchyExist = false),
          (this.hierarchyVisible = false),
          (this.fetchBasedOnAllParents = false));
      },
      getImageFields(entity) {
        return entity?.templates_with_fields
          ?.map((template) => template.sections[0].fields) // Get fields array from each template
          .flat()
          .filter((field) => field.inputType === 'IMAGE');
      },
      async saveHierarchy() {
        this.loadingDrawer = true;
        if (!this.isHierarchyExist) {
          await postAPICall('POST', '/save-hierarachy', {
            company_id: this.getActiveWorkspace.company_id,
            entity_id: this.hierarchyEntity._id,
            hierarchy_mode: this.hierarchyMode,
            ...(this.hierarchyMode && this.hierarchyMode == 'role'
              ? { role_settings: this.roleSettings }
              : {
                  wanted_hierarchy_list: this.wantedHierarchyList.map((entity) => ({
                    entity_id: entity.entity_id,
                    selectedImage: entity.selectedImage,
                  })),
                  hierarchy_list: this.hierarchyList.map((entity) => entity._id),
                  isCheckAllParentEntityIds: this.fetchBasedOnAllParents,
                }),
          });
        } else {
          await postAPICall('PUT', '/update-hierarachy', {
            hierarchy_data: {
              company_id: this.getActiveWorkspace.company_id,
              entity_id: this.hierarchyEntity._id,
              hierarchy_mode: this.hierarchyMode,
              ...(this.hierarchyMode && this.hierarchyMode == 'role'
                ? { role_settings: this.roleSettings }
                : {
                    wanted_hierarchy_list: this.wantedHierarchyList.map((entity) => ({
                      entity_id: entity.entity_id,
                      selectedImage: entity.selectedImage,
                    })),
                    hierarchy_list: this.hierarchyList.map((entity) => entity._id),
                    isCheckAllParentEntityIds: this.fetchBasedOnAllParents,
                  }),
            },
          });
        }
        this.$notify.success({
          message: this.isHierarchyExist
            ? 'Entity Hierarchy updated successfully'
            : 'Entity Hierarchy saved successfully!',
          title: 'success',
        });
        this.hierarchyVisible = false;
        this.isHierarchyExist = false;
        this.fetchBasedOnAllParents = false;
        this.loadingDrawer = false;
      },
      removeLevel(index) {
        this.wantedHierarchyList.splice(index, this.wantedHierarchyList.length - index);
      },
      resetHierarchy() {
        this.wantedHierarchyList.splice(1);
      },
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.iconPickerdialogVisible = false;
      },
      async fetchGroupDetails() {
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
          await this.$store.dispatch(
            'roles/fetchRoleById',
            this.getAuthenticatedUser.activeRole.role_id
          );
          if (this.$route.query.group && this.$route.query.group.length) {
            await this.$store.dispatch(
              'entityGroups/fetEntityGroupDataById',
              this.$route.query.group
            );
          }
        }
      },
      showAddgroupDialog() {
        this.showAddGroupDialog = false;
      },
      sendNotificationsDialog() {
        this.sendNotificationDialog = false;
        this.sendWANotificationDialog = false;
      },
      entityDataRulesModalDialog() {
        this.entityDataRulesModal = false;
      },
      showPermissionDialog() {
        this.showPermissionsDialog = false;
      },
      handleCloseDialog() {
        this.showRBACPermissionsDialog = false;
      },
      showCustomMenuDialog() {
        this.showMenuDialog = false;
        this.showRBACMenuDialog = false;
      },
      async moveToFolder(folderId) {
        this.refresh = true;
        this.folder = folderId != 'root' ? folderId : '';
        let query = this.getNavigationQuery(this.$route.query);
        if (this.folder) {
          query['folder'] = this.folder;
        } else {
          if (query.folder) {
            delete query.folder;
          }
        }
        this.$router.push({
          name: this.$route.name,
          query: query,
        });
        setTimeout(() => {
          this.refresh = false;
        }, 500);
      },
      fileManagementModalReset() {
        if (this.$route.query.folder) {
          const query = { ...this.$route.query };
          delete query.folder;
          this.$router.replace({ query });
        }
        this.folder = '';
        this.fileManagementModal = false;
        this.selectedFileEntity = null;
      },
      openFiles(entity) {
        this.selectedFileEntity = entity._id;
        this.fileManagementModal = true;
      },
      async openSendNotification(entity) {
        this.selectedNotifyEntity = entity;
        this.sendNotificationDialog = true;
        this.sendWANotificationDialog = false;
      },
      async openSendWANotification(entity) {
        console.log('WA Notification', entity);
        this.selectedNotifyEntity = entity;
        this.sendNotificationDialog = false;
        this.sendWANotificationDialog = true;
      },
      //Entity notification variables
      async closeBulkSendNotificationDialog(params) {
        this.entityNotificationLoading = true;
        if (params.attachments && params.attachments?.length && params.event_type == 'WA') {
          this.loadingText = 'Uploading Files';
          let files = params.attachments.map((e) => {
            return {
              name: e.filename,
              mimetype: e.type,
              data: e.content,
              size: e.size,
            };
          });
          let paramsData = {
            files: files,
            path: 'email-attachments',
          };
          await this.$store.dispatch('s3FileUpload/uploadMultipleBase64Files', paramsData);
          if (this.getFileUploadData && this.getFileUploadData.length) {
            params.attachments = this.getFileUploadData;
          }
        }
        this.loadingText = 'Saving Data';
        await this.$store.dispatch('entities/sendNotificationToAllUsers', params);
        if (this.getSentEntityNotificationStatus) {
          this.emailConfigLoading = false;
          if (this.sendNotificationDialog) {
            this.$notify({
              title: 'Success',
              message: 'Sending Email message',
              type: 'success',
            });
          } else {
            this.$notify({
              title: 'Success',
              message: 'Messages initiated',
              type: 'success',
            });
          }
        } else {
          this.emailConfigLoading = false;
          this.$notify({
            title: 'Error',
            message: this.getSentEntityNotificationStatusErrors.message,
            type: 'error',
          });
        }
        this.entityNotificationLoading = false;
        this.sendNotificationDialog = false;
        this.sendWANotificationDialog = false;
      },
      selectScratchbox() {
        this.isCreateFromScratchSelected = true;
        this.isCreateFromExcelSelected = false;
        this.selectedEntityCreationType = 'scratch';
      },
      selectExcelbox() {
        this.isCreateFromScratchSelected = false;
        this.isCreateFromExcelSelected = true;
        this.selectedEntityCreationType = 'excel';
      },
      async openCustomDashboard(data) {
        this.loading = true;
        if (data.login_mode === 'rbac') {
          this.$router.push({
            path: `/ap-user/custom-dashboards/${data._id}/rbac`,
            query: {
              name: data.name,
            },
          });
          this.loading = false;
        } else {
          this.$router.push(`/ap-user/custom-dashboards/${data._id}?name=${data.name}`);
          this.loading = false;
        }
      },
      resetEntityPermissions() {
        this.showPermissionsDialog = false;
        this.showRBACPermissionsDialog = false;
      },
      resetEntityRules() {
        this.entityDataRulesModal = false;
      },
      async saveEntityRules(data, data1, data2, data3) {
        this.loading = true;
        let params = {
          delete_rules: data,
          delete_condition: data1,
          editable_fields: data3,
          id: this.selectedEntity._id,
          edit_filter: data2,
        };
        await this.$store.dispatch('entities/updateEntityById', params);
        console.log('currentEntity', this.selectedEntity);
        if (this.getEntityDataUpdateStatus) {
          this.loading = false;
          updateEntityData(this.selectedEntity._id, {
            ...this.selectedEntity,
            ...params,
          });
          this.resetEntityRules();
          this.$notify({
            title: 'Success',
            message: 'Entity delete rules updated successfully',
            type: 'success',
          });
          this.fetchEntities();
        } else {
          this.loading = false;
          this.$notify({
            title: 'Error',
            message: 'Error while updating entity',
            type: 'error',
          });
        }
      },
      async saveEntityPermissions(permissions) {
        this.loading = true;
        await this.$store.dispatch('entities/updateEntityById', {
          permissions: permissions,
          id: this.selectedEntity._id,
        });
        if (this.getEntityDataUpdateStatus) {
          this.loading = false;
          this.resetEntityPermissions();
          this.$notify({
            title: 'Success',
            message: 'Entity permissions updated successfully',
            type: 'success',
          });
          this.fetchEntities();
        } else {
          this.loading = false;
          this.$notify({
            title: 'Error',
            message: 'Error while updating entity',
            type: 'error',
          });
        }
      },
      //open permissions dialog
      openPermissionsDialog(data) {
        this.selectedEntity = null;
        this.selectedEntity = data;
        this.showPermissionsDialog = true;
      },
      openRBACPermissionsDialog(data) {
        this.selectedEntity = null;
        this.selectedEntity = data;
        this.showRBACPermissionsDialog = true;
      },
      async fetchAssignedRoleInformation(role) {
        this.loading = true;
        try {
          await this.$store.dispatch('roles/fetchRoleById', role.role_id);
        } catch (err) {
          console.log('fetchAssignedRoleInformation', err);
        }
      },
      openMenuDialog(data) {
        this.selectedEntity = null;
        this.selectedEntity = data;
        this.showMenuDialog = true;
      },
      openRBACMenuDialog(data) {
        this.selectedEntity = null;
        this.selectedEntity = data;
        this.showRBACMenuDialog = true;
      },

      /*  ***Fetch Groups  start  **** */
      async fetchCompanyGroups() {
        try {
          const groups = await fetchGroups({
            get_all: true,
          });
          if (groups?.data) {
            this.getAllEntityGroupsData = [...groups.data];
            this.entityGroupsData = [groups.data[0]._id];
          }
        } catch (e) {
          console.log('fetchCompanyGroups', e);
        }
      },
      /*  ***Fetch Groups  end  **** */
      async sortChange(a) {
        this.order_by = a.prop;
        this.order_type = a.order == 'ascending' ? 'asc' : 'desc';
        this.fetchEntities();
        if (a.order == null) {
          this.order_by = null;
          this.order_type = null;
          this.fetchEntities();
        }
      },
      async refreshEntities() {
        this.currentPage = 1;
        this.pageSize = 10;
        this.fetchEntities();
      },
      searchString() {
        this.pageSize = 10;
        this.page = 1;
        this.fetchEntities();
      },
      async loadData(data) {
        if ((data && data.type != 'init') || !data) {
          this.pageSize = data.pageSize;
          this.page = data.page;
          await this.fetchEntities();
        }
      },
      async goToEntity(data) {
        let query = this.getNavigationQuery(this.$route.query);
        this.$router.push({
          name: 'entities-Data',
          params: {
            entity_id: data._id,
          },
          query: query,
        });
      },
      async goToNewLink(data) {
        let query = this.getNavigationQuery(this.$route.query);
        this.$router.push({
          path: `/entity/v2/${data._id}`,
          query: query,
        });
      },
      async onEdit(document) {
        if (!this.checkAppMode()) {
          return;
        }
        if (this.getIframeUrlInfo == null) {
          if (
            this.getAuthenticatedUser &&
            document &&
            document.created_by != this.getAuthenticatedUser._id &&
            !this.checkPermissionByPermissionName('editEntity')
          ) {
            this.$notify.error({
              title: 'Error',
              message: 'Permission denied for edit entities.Please contact owner.',
            });
          } else {
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              name: 'Edit Entity',
              params: {
                entity_id: document._id,
              },
              query: query,
            });
          }
        }
      },
      onAssignToCompany(document) {
        console.log(document);
      },
      onRules(data) {
        this.selectedEntity = null;
        this.selectedEntity = data;
        this.entityDataRulesModal = true;
      },
      async fetchExistedHierarchy() {
        return await postAPICall('GET', '/fetch-existed-hierarchy', {
          entity_id: this.hierarchyEntity._id,
        });
      },
      async fetchHierarchyBasedOnRelationship() {
        this.loadingText = `Please wait while fetching ${this.hierarchyEntity.name} hierarchy based on relationships...`;
        const [existedHierarchy, response] = await Promise.all([
          this.fetchExistedHierarchy(),
          postAPICall('GET', '/entity-hierarchy', {
            isIncludeAllEntities: false,
            entity_id: this.hierarchyEntity._id,
            isFetchEntityInformation: true,
          }),
        ]);
        if (!existedHierarchy.data || existedHierarchy.data.hierarchy_mode == 'role') {
          this.hierarchyList = response.data;
          this.wantedHierarchyList = [
            {
              entity_id: this.hierarchyList[0]._id,
              selectedImage: null,
              entity: this.hierarchyList[0],
              imageFields: this.getImageFields(this.hierarchyList[0]),
            },
          ];
        } else {
          this.hierarchyList = JSON.parse(JSON.stringify(response.data));
          this.isHierarchyExist = true;
          const hierarchyMap = Object.fromEntries(
            response.data.map((entity) => [entity._id, entity])
          );
          this.wantedHierarchyList = await Promise.all(
            existedHierarchy.data.wanted_hierarchy_list.map(async (entity) => {
              const matchedEntity = hierarchyMap[entity.entity_id];
              return {
                ...entity,
                entity: matchedEntity,
                imageFields: await this.getImageFields(matchedEntity),
              };
            })
          );
          this.fetchBasedOnAllParents = existedHierarchy.data.isCheckAllParentEntityIds;
        }
        this.wantedHierarchyList.forEach(async (entity, index) => {
          if (index == 0) {
            this.availableOptionsPerLevel[0] = [this.hierarchyList[0]];
          } else {
            let response = await postAPICall('GET', '/fetch-parent-related-entities', {
              entity_id: this.wantedHierarchyList[index - 1].entity_id,
            });
            if (response.data.length) {
              const filtered = this.hierarchyList.filter((entity) =>
                response.data.includes(entity._id)
              );
              this.$set(this.availableOptionsPerLevel, index, filtered);
            }
          }
        });
      },
      async openHierarchy(document) {
        this.isRBACEnabled = document.login_mode === 'rbac' ? true : false;
        this.hierarchyEntity = document;
        let existedHierarchy = await this.fetchExistedHierarchy();
        this.hierarchyEntityName = document.name + ' Hierarchy Configuration';
        if (existedHierarchy.data && existedHierarchy.data.hierarchy_mode == 'relationship') {
          this.configureLoading = true;
          this.hierarchyMode = existedHierarchy.data.hierarchy_mode;
          await this.fetchHierarchyBasedOnRelationship();
          this.configureLoading = false;
        } else {
          if (!existedHierarchy.data) {
            this.roleSettings.role_details = document.role_details ? document.role_details : {};
          } else {
            this.isHierarchyExist = true;
            this.hierarchyEntityFields = await this.fetchEntityDetails(
              this.hierarchyEntity._id,
              true,
              true
            );
            this.hierarchyMode = existedHierarchy.data.hierarchy_mode;
            this.roleSettings.role_details = existedHierarchy.data.role_settings.role_details;
            this.roleSettings.role_name = existedHierarchy.data.role_settings.role_name;
            this.roleSettings.reported_to = existedHierarchy.data.role_settings.reported_to;
          }
        }
        this.hierarchyVisible = true;
      },
      async onHierarchyModeChange(mode) {
        if (mode === 'relationship') {
          this.loadingDrawer = true;
          await this.fetchHierarchyBasedOnRelationship();
          this.loadingDrawer = false;
        } else {
          this.hierarchyEntityFields = await this.fetchEntityDetails(
            this.hierarchyEntity._id,
            true,
            true
          );
        }
      },
      async onView(document) {
        if (
          this.getAuthenticatedUser &&
          document &&
          document.created_by != this.getAuthenticatedUser._id &&
          !this.checkPermissionByPermissionName('viewEntity')
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for view entities.Please contact owner.',
          });
        } else {
          let urlName = '';
          if (this.getIframeUrlInfo?.url_type) {
            urlName = 'EntityData1_External';
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              name: urlName,
              params: {
                entity_id: document._id,
              },
              query: query,
            });
          } else if (document.external_config?.isIntegrationConfig) {
            urlName = 'ExternalView';
            this.$router.push({
              name: urlName,
              params: {
                entity_id: document._id,
              },
            });
          } else {
            urlName = 'EntityData';
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              name: urlName,
              params: {
                entity_id: document._id,
              },
              query: {
                ...query,
                viewType: document.viewType || 'TABLE',
              },
            });
          }
        }
      },
      destroyCreateModal() {
        this.entityName = '';
        this.description = '';
        this.isAccount = false;
        this.entity_type = 'GENERAL';
        this.isCreateFromScratchSelected = true;
        this.isCreateFromExcelSelected = false;
        this.selectedEntityCreationType = 'scratch';
        this.newEntityModal = false;
      },
      async openNewEntity() {
        let hasUnlimitedAccess = await this.getAccessToEachFeatureWithUnlimited('entities');
        if (hasUnlimitedAccess) {
          this.hasAccess = true;
        } else {
          this.hasAccess = await this.getAccessToEachFeatureWithLimit('entities');
        }
        if (!this.hasAccess) {
          this.$notify.warning({
            title: 'Access Denied',
            message: 'Entities limit reached.',
            duration: 3000,
          });
          return;
        } else {
          if (!this.checkPermissionByPermissionName('createEntity')) {
            this.$notify.error({
              title: 'Error',
              message: 'Permission denied for creating entities.Please contact owner.',
            });
          } else {
            this.newEntityModal = true;
            this.fetchCompanyGroups();
          }
        }
      },
      async createEntity() {
        let params = {
          icon: this.templateIconPath,
          name: this.entityName.trim(),
          description: this.description,
          entity_type: this.entity_type,
          isAccount: this.isAccount,
          isRestrictMultiple: this.isRestrictMultiple,
          entityGroups: this.$route.query.group ? [this.$route.query.group] : this.entityGroupsData,
        };
        if (this.isCreateFromScratchSelected === true || this.isCreateFromExcelSelected === true) {
          if (this.isCreateFromScratchSelected === true) {
            if (params.entityGroups && params.entityGroups.length) {
              await this.$store.dispatch('entities/createNewEntity', params);
              if (this.getEntityCreatedStatus) {
                if (this.getEntityCreatedData) {
                  addSingleEntityToLocal(this.getEntityCreatedData);
                }
                this.$notify.success({
                  title: 'Success',
                  message: 'Entity created successfully',
                });
                let params = this.getNavigationQuery(this.$route.query);
                this.$router.replace({
                  path: `/entity/${this.getEntityCreatedData._id}/edit`,
                  query: params,
                });
              } else {
                this.$notify.error({
                  title: 'Error',
                  message: this.getEntityErrors || 'Error on creating Entity',
                });
              }
            } else {
              this.$message.warning('Please choose at least one Group');
            }
          }
          if (this.isCreateFromExcelSelected === true) {
            if (params.entityGroups && params.entityGroups.length) {
              await this.$store.dispatch('entities/createNewEntity', params);
              if (this.getEntityCreatedStatus) {
                this.$notify.success({
                  title: 'Success',
                  message: 'Entity created successfully',
                });
                this.$router.push({
                  name: 'entity-from-excel',
                  params: {
                    entity_id: this.getEntityCreatedData._id,
                  },
                });
              } else {
                this.$notify.error({
                  title: 'Error',
                  message: this.getEntityErrors || 'Error on creating Entity',
                });
              }
            } else {
              this.$message.warning('Please choose at least one Group');
            }
          }
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'please select either "Create from scratch" or "Create from excel" ',
          });
        }
      },
      async fetchEntities() {
        try {
          this.configureLoading = true;
          if (this.pageSize == 0) {
            this.pageSize = 10;
          }
          let params = {
            limit: this.pageSize,
            page: this.page,
          };
          if (this.search_string) {
            params.search_string = this.search_string;
          }
          if (this.order_by) {
            params.order_by = this.order_by;
          }
          if (this.order_type) {
            params.order_type = this.order_type;
          }
          if (this.selectedType) {
            params.entity_type = this.selectedType;
          }
          if (this.templateIconPath) {
            params.icon = this.templateIconPath;
          }
          if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
            if (this.$route.query.group && this.$route.query.group.length) {
              params.group = this.$route.query.group;
            } else {
              if (this.getRoleById && this.getRoleById) {
                params.groups = this.getRoleById.allowed_groups;
              }
            }
          }
          const getAllEntities = await fetchEntitiesByPagination(params);
          if (getAllEntities) {
            this.allEntities = [...getAllEntities.data];
            this.total = getAllEntities && getAllEntities.total ? getAllEntities.total : 0;
            this.currentPage = parseInt(getAllEntities.page) || 1;
            this.loadIconsforEntities();
            this.configureLoading = false;
          } else {
            this.configureLoading = false;
          }
        } catch (err) {
          console.log('fetchEntities', err);
        }
      },
      async loadIconsforEntities() {
        const companyId = this.getActiveWorkspace.company_id;
        const key = `${companyId}:entities`;
        const icons = [];
        try {
          const entities = this.allEntities;
          entities.forEach((entity) => {
            if (entity.icon) {
              icons.push(entity.icon);
            }
          });
          const iconKeys = await getIconKeysFromMasterIcons(icons);
          await createIcons(key, iconKeys);
        } catch (error) {
          console.error('Error while loading company template icons:', error);
        }
      },
      async onDelete(row) {
        if (!this.checkAppMode()) return;
        if (
          this.getAuthenticatedUser &&
          row &&
          row.created_by != this.getAuthenticatedUser._id &&
          !this.checkPermissionByPermissionName('deleteEntity')
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for deleting entities.Please contact owner.',
          });
        } else {
          this.$confirm('Are you sure to delete the Entity?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.deleteEntity(row);
          });
        }
      },
      async deleteEntity(template) {
        let params = {
          id: template._id,
        };
        await this.$store.dispatch('entities/deleteEntity', params);
        await deleteEntity(template._id);
        this.refreshEntities();
        if (this.getEntityDeleteStatus) {
          this.$notify.success({
            title: 'Success',
            message: 'Entity deleted successfully',
          });
          this.fetchEntities();
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getEntityDeleteError || 'Error on deleting Entity',
          });
        }
      },
      async addGroupPopUP() {
        this.showAddGroupDialog = true;

        await this.$store.dispatch('entityGroups/resetErrors');
      },
      async saveGroup() {
        this.loadingSaveGroup = true;
        await this.$store.dispatch('entityGroups/addEntityGroup', {
          name: this.entitiesListForm.groupName,
          description: '',
          entities: [],
        });
        if (this.getSingleEntityGroupData && this.getSingleEntityGroupData.success) {
          await addSingleGroupToLocal(this.getSingleEntityGroupData.data);
          this.fetchCompanyGroups();
          this.loadingSaveGroup = false;
          this.entitiesListForm.groupName = '';
          this.showAddGroupDialog = false;
          this.entityGroupsData.push(this.getSingleEntityGroupData.data._id);
        } else if (this.getError && !this.getError.success) {
          this.loadingSaveGroup = false;
          let msg =
            this.getError && this.getError.message ? this.getError.message : 'Something went wrong';
          this.$message.warning(msg);
        }
      },
      async exportAllEntityData() {
        this.$confirm('Do you want to export all the entities ?', 'Are you sure ?', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(async () => {
          this.configureLoading = true;
          let currentWorkspace = this.getActiveWorkspace;
          let userWorkspaceList = this.getWorkspaceList;
          let currentWorkspaceInWorkspacesList = userWorkspaceList.find(
            (e) => e.company_id._id.toString() == currentWorkspace.company_id.toString()
          );
          let params = {
            companyName: currentWorkspaceInWorkspacesList.company_id.name,
          };
          await this.$store.dispatch('entities/allEntitiesDataExport', params);
          this.configureLoading = false;
        });
      },
      openViewConfigPage() {
        ((this.url_key = this.$route.fullPath), (this.copyModal = true));
      },
      // Methods to handle email config button clicks
      handleSaveAsTemplate() {
        if (this.$refs.emailConfigRef) {
          this.$refs.emailConfigRef.handleSaveAsTemplate();
        }
      },
      handleSendNotification() {
        if (this.$refs.emailConfigRef) {
          this.$refs.emailConfigRef.sendNotification();
        }
      },
    },
    watch: {
      '$route.query.group'() {
        this.fetchEntities();
      },
      '$route.query.key'() {
        this.fetchEntities();
      },
    },
    beforeDestroy() {
      this.$store.commit(
        'navigationOpen/setCurrentMenu',
        {},
        {
          root: true,
        }
      );
      this.$store.commit('entities/setAllEntities', null, { root: true });
      this.$store.commit('entities/setEntityDataUpdateStatus', false, {
        root: true,
      });
      this.$store.commit('entities/setSentEntityNotificationStatus', false, {
        root: true,
      });
      this.$store.commit('entities/setEntityCreatedData', null, { root: true });
      this.$store.commit('entities/setEntityDeleteStatus', false, { root: true });
      this.$store.commit('entities/setAllEntityDataExportStatus', false, {
        root: true,
      });

      this.$store.commit('entityGroups/setEntityGroupErrors', {}, { root: true });
      this.$store.commit('entityGroups/setSingleEntityGroupData', {}, { root: true });
      this.$store.commit(
        'entityGroups/setAllEntityGroupsData',
        { data: [], total: 0, page: 0 },
        { root: true }
      );
      this.$store.commit('entityGroups/setEntityGroupDataAddStatus', false, {
        root: true,
      });
    },
    errorCaptured(error, compInst, errorInfo) {
      console.log('error: ', error);
      console.log('compInst: ', compInst);
      console.log('errorInfo: ', errorInfo);
    },
  };
</script>
<style scoped lang="scss">
  .main-container {
    gap: 10px !important;
    align-items: center;
  }

  .search ::v-deep .el-input__inner {
    font-family: var(--font-family);
  }

  .doc-title {
    cursor: pointer;
    font-size: 14px;
    font-family: var(--font-family);
    font-weight: 300;
    line-height: 14px;
    text-align: left;
    color: #6c757d !important;
  }

  .activestatus {
    font-size: 14px;
    color: #6c757d !important;
  }

  .circle {
    position: relative;
    padding-left: 20px;
    text-transform: capitalize;
    font-size: 14px;

    &::after {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      height: 10px;
      width: 10px;
      display: inline-block;
      border-radius: 50%;
    }

    &.active::after {
      background: #08ad36;
    }

    &.inactive::after {
      background: #f562b3;
    }

    &.deleted::after {
      background: #8b1702;
    }

    &.archived::after {
      background: #404040;
    }

    &.disable::after {
      background: #c4c4c4;
    }

    &.viewed::after {
      background: #2f80ed;
    }
  }

  .name-types {
    .filename {
      height: 35px;
      margin-top: 5px;
      cursor: pointer;
      background: #ffffff;

      .el-upload-list__item-name {
        .img-active {
          visibility: hidden;
          width: 6px !important;
          margin-right: 10px;
          margin-left: 10px;
          position: relative;
          top: 3px;
        }

        .img-fluid {
          position: relative;
          top: 5px;
          width: 18.43px !important;
        }
      }
      .direction-buttons {
        display: flex;
        visibility: hidden;
        position: relative;
        top: -35%;
        left: 97%;

        .directions {
          position: relative;
          right: 10%;
          top: -10px !important;
        }
      }

      &:hover {
        .img-active {
          visibility: visible;
          width: 6px !important;
          margin-right: 10px;
          margin-left: 10px;
          position: relative;
          top: 3px;
        }

        .direction-buttons {
          display: flex;
          visibility: visible;
          position: relative;
          top: -35%;
          left: 97%;

          .directions {
            position: relative;
            right: 10%;
            top: -10px !important;
          }
        }
      }
    }
  }

  .custom-emails-input {
    margin-top: 0.5rem;
  }

  .info-button {
    border: none;
    margin-left: 10px;
    padding: 2px;
  }

  .attachments {
    display: flex;
    justify-content: center;
    margin: 5px;
  }

  .document {
    width: 180px;
    margin: 10px;
  }

  .upload-demo {
    margin: 10px;
  }
</style>
<style lang="scss" scoped>
  .top-buttons-wrapper {
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    @media (max-width: 991.98px) {
      display: flex;
      margin-top: 20px;
    }
  }

  .new-entity-information {
    .el-dialog {
      width: 800px;
      padding-bottom: 15px;

      @media (max-width: 800px) {
        width: 700px;
        margin-top: 40px !important;
      }

      @media (max-width: 700px) {
        width: 600px;
        margin-top: 40px !important;
      }

      @media (max-width: 600px) {
        width: 500px;
        margin-top: 40px !important;
      }

      @media (max-width: 500px) {
        width: 400px;
        margin-top: 40px !important;
      }

      @media (max-width: 400px) {
        width: 300px;
        margin-top: 40px !important;
      }

      .entity-type-radio {
        @media (max-width: 400px) {
          & > label {
            & > span {
              padding-left: 5px !important;
              padding-right: 5px !important;
            }
          }
        }
      }
    }
  }

  .entity-type-box {
    border: 1px solid var(--page-border);
    margin-right: 1rem;
    border-radius: 3px;
    padding: 10px;

    &:last-child {
      margin-right: 0 !important;
    }
  }

  .el-tooltip.el-icon-circle-plus-outline::before {
    font-size: 20px;
  }

  .el-tooltip.el-icon-circle-plus-outline:hover {
    transform: scale(1.03);
  }
</style>
<style lang="scss" scoped>
  .notifying-email .el-dialog__body {
    max-height: 60vh;
    padding: 1em 1.5em;
    overflow-y: auto;
    /* or scroll */
    overflow-x: hidden;

    /* Reset styles for the webkit scrollbar in el-dialog__body */
    &::-webkit-scrollbar {
      width: initial;
      height: initial;
    }

    &::-webkit-scrollbar-thumb {
      width: initial;
      height: initial;
      border-radius: initial;
      background-clip: initial;
      border: initial;
    }

    /* Add the specific styles for the webkit scrollbar in el-dialog__body */
    &::-webkit-scrollbar {
      width: 6px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      width: 6px;
      height: 0px;
      border-radius: 10px;
      background-clip: padding-box;
      border: 10px solid rgba(0, 0, 0, 0.28);
    }
  }

  .vue-data-table-default tbody tr td:first-child {
    padding: 0px 10px;
  }

  .entity-add-btn {
    height: 30px;
    font-size: 21px;
    font-weight: 10px;
    margin-left: 11px;
    display: flex;
    align-items: center;
  }

  .data-import-btn {
    border-width: 1px;
    border-radius: 2px;
    background-color: #ffffff;
    border-color: var(--brand-500);
    border-style: solid;
    font-size: 14px !important;

    &:hover {
      background-color: var(--brand-500);
      color: #ffffff;
      border-color: var(--brand-500);
    }
  }

  .export-import-logo {
    margin-right: 10px;
  }

  .export-all {
    margin: 0 0.5rem;
  }

  .el-button:focus,
  .el-button:hover {
    color: var(--brand-500) !important;
    border-color: var(--brand-500) !important;
    background-color: white !important;
  }
</style>
<style lang="scss" scoped>
  .bt ul {
    margin-top: 0;
    margin-bottom: 0rem !important;
  }

  .el-button--mini {
    padding: 2px 15px !important;
  }

  .radio-group {
    margin-right: 10px;

    @media (max-width: 1360px) {
      display: flex;
    }
  }

  @media (max-width: 1366px) {
    .radio-group {
      justify-content: space-between;
      display: flex;
      margin-right: 10px;
    }
  }

  .el-input,
  .el-textarea {
    display: inline-block;
    width: 98%;
  }

  p {
    margin-bottom: 0rem;
  }
  .bt .btn-outline-primary {
    color: white !important;
    background: var(--brand-500) !important;
    &:active:focus {
      color: white !important;
      background: var(--brand-500) !important;
      box-shadow: 0 0 0 0.2rem var(--primary-color-brand) !important;
    }
  }
</style>
<style scoped>
  ::v-deep(.custom-menu-style .dialog-content) {
    scrollbar-width: none;
    overflow-y: hidden;
  }

  .el-button--primary {
    background-color: var(--brand-500);
  }

  .el-message-box__btns button:nth-child(2) {
    background-color: var(--brand-500) !important;
    background: var(--brand-500) !important;
  }

  /* Override the background color of the confirm dialog */
  .custom-confirm-style .el-message-box {
    background-color: #fce4ec !important;
  }
</style>
